import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(private http: HttpClient) {}

  private formatErrors(error: any): Observable<never> {
    return throwError(error.error);
  }

  get(
    path: string,
    params: HttpParams = new HttpParams(),
    header?: HttpHeaders,
    observe?: any
  ): Observable<any> {
    return this.http
      .get(environment.REST_CONFIG.API_URL + path, {
        headers: header,
        params,
        observe,
      })
      .pipe(catchError(this.formatErrors));
  }

  getV2(
    path: string,
    params: HttpParams = new HttpParams(),
    header?: HttpHeaders,
    observe?: any
  ): Observable<any> {
    return this.http
      .get(environment.REST_CONFIG.API_URL_V2 + path, {
        headers: header,
        params,
        observe,
      })
      .pipe(catchError(this.formatErrors));
  }

  post(
    path: string,
    body: any = {},
    headers?: HttpHeaders,
    params?: HttpParams,
    observe?: any
  ): Observable<any> {
    return this.http
      .post(environment.REST_CONFIG.API_URL + path, JSON.stringify(body), {
        headers,
        params,
        observe,
      })
      .pipe(catchError(this.formatErrors));
  }

  postV2(
    path: string,
    body: any = {},
    headers?: HttpHeaders,
    params?: HttpParams,
    observe?: any
  ): Observable<any> {
    return this.http
      .post(environment.REST_CONFIG.API_URL_V2 + path, JSON.stringify(body), {
        headers,
        params,
        observe,
      })
      .pipe(catchError(this.formatErrors));
  }
}
